
import { mapState, mapGetters } from 'vuex'
import buildURL from 'axios/lib/helpers/buildURL'
import streamSaver from 'streamsaver'
import eventBus from '~/event-bus'
const LinkHeader = require('http-link-header')

export default {
  props: ['params', 'total'],
  data () {
    return {
      menu: false,
      largeCsvLoading: false,
      largeCsvBufferValue: 0,
      largeCsvValue: 0,
      largeCsvCancelled: false
    }
  },
  computed: {
    ...mapState(['env']),
    ...mapState('dataset', ['dataset']),
    ...mapGetters('dataset', ['resourceUrl']),
    downloadUrls () {
      const params = {
        ...this.params,
        size: 10000,
        page: 1
      }
      delete params.truncate
      return {
        csv: buildURL(this.resourceUrl + '/lines', { ...params, format: 'csv' }),
        xlsx: buildURL(this.resourceUrl + '/lines', { ...params, format: 'xlsx' }),
        ods: buildURL(this.resourceUrl + '/lines', { ...params, format: 'ods' }),
        geojson: buildURL(this.resourceUrl + '/lines', { ...params, format: 'geojson' })
      }
    }
  },
  methods: {
    async downloadLargeCSV () {
      this.largeCsvCancelled = false
      this.largeCsvLoading = true
      try {
        const { WritableStream } = await import('web-streams-polyfill/ponyfill')
        streamSaver.WritableStream = WritableStream
        streamSaver.mitm = `${this.env.publicUrl}/streamsaver/mitm.html`
        this.fileStream = streamSaver.createWriteStream(`${this.dataset.slug}.csv`)
        this.writer = this.fileStream.getWriter()
        const nbChunks = Math.ceil(this.total / 10000)
        let nextUrl = this.downloadUrls.csv
        for (let chunk = 0; chunk < nbChunks; chunk++) {
          if (this.largeCsvCancelled) break
          this.largeCsvBufferValue = ((chunk + 1) / nbChunks) * 100
          let res
          try {
            res = await this.$axios.get(nextUrl)
          } catch (err) {
            // 1 retry after 10s for network resilience, short service interruption, etc
            await new Promise(resolve => setTimeout(resolve, 10000))
            res = await this.$axios.get(nextUrl)
          }

          const { data, headers } = res
          if (headers.link) {
            const next = new URL(LinkHeader.parse(headers.link).rel('next')[0].uri)
            next.searchParams.set('header', false)
            nextUrl = next.href
          }
          await this.writer.write(new TextEncoder().encode(data))
          this.largeCsvValue = ((chunk + 1) / nbChunks) * 100
        }
        if (!this.largeCsvCancelled) {
          this.writer.close()
          this.clickDownload('csv')
        }
      } catch (error) {
        if (!this.largeCsvCancelled && !!error) {
          console.log('download large csv error', error)
          eventBus.$emit('notification', { error })
        }
      }
      this.largeCsvLoading = false
      this.largeCsvCancelled = false
      this.largeCsvBufferValue = 0
      this.largeCsvValue = 0
    },
    /* cancel works, but the next download stays in pending state I don't know why */
    async cancelLargeCsv () {
      this.largeCsvCancelled = true
      if (this.writer) {
        this.writer.releaseLock()
        this.fileStream.abort()
      }
    },
    clickDownload (format) {
      parent.postMessage({ trackEvent: { action: 'download_filtered', label: `${this.dataset.slug} - ${format}` } })
      this.menu = false
    }
  }
}
